import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useKeycloak } from '@react-keycloak/web'
import { Equalizer, TrendingUp, Add } from '@material-ui/icons/'

import SimpleInputField from '../../Custom/CustomInput/SimpleInputField'
import searchPageContext from '../../FiltersComponent/context/context'
import { clearSelectedProperties, viewList, getUserSFId, getErrorAlertDuration } from '../../Utility/Utility'
import updatePropertyList from '../../../PropertyList/Utility/UpdatePropertyList/UpdatePropertyList'
import { pollMessageStatus } from '../../../PropertyList/Utility/GetMessageStatus/GetMessageStatus'

// import { useHistory } from 'react-router-dom'

const SaveNewList = props => {
    const { keycloak } = useKeycloak()
    const [listName, setListName] = useState('')
    const [listType, setListType] = useState('')
    const [optionsList, setOptionsList] = useState([])
    const { fetchSavedLists, searchCriteria, setShowAlert, setalertProps, searchResult,
        setSearchResult, savedLists, setSelectedMenu, openModalWindow } = useContext(searchPageContext)
    const [saveClicked, setSaveClicked] = useState(false)
    const [selectedPropertyCount, setSelectedPropertyCount] = useState(0)
    useEffect(() => {
        let list = []
        searchResult.property.forEach((prop) => {
            if (prop.checked || (prop.omniViewPropertyId == searchCriteria.subjectProperty.omniViewPropertyId)) {
                list.push(
                    {
                        "omniViewPropertyId": prop.omniViewPropertyId,
                        "isSubjectProperty": searchCriteria.subjectProperty && (prop.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId),
                        "rank": (list.length + 1),
                        "label": prop.propertyName
                    })

                if (listName === '' && searchCriteria.subjectProperty && (prop.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId)) {
                    if (searchCriteria.subjectProperty.propertyName) {
                        setListName(searchCriteria.subjectProperty.propertyName)
                    }
                }
            }
        })
        setOptionsList(list)
        setSelectedPropertyCount(searchResult.property.filter(row => row.checked).length)
    }, [searchResult])

    useEffect(() => {
        if (saveClicked) {
            handleSave()
        }
    }, [saveClicked])

    function handleChange(e) {
        let { value } = e.target
        setListName(value)
    }

    // const onChange = ($event) => {
    //     console.log($event)
    //     optionsList.forEach((prop, index) => {
    //         prop.isSubjectProperty = index === $event.currentTarget.selectedIndex ? true : false
    //     })
    // }

    const getPayload = () => {
        const user_SFId = getUserSFId()
        let fieldsToUpdate = []
        // const newSearchCriteria = getSearchCriteriaToSave(searchCriteria)
        const selectedProps = []

        let subjectProperties = optionsList.filter(x => x.isSubjectProperty)
        let nonSubjectProperties = optionsList.filter(x => !x.isSubjectProperty)

        let propertyList = [...subjectProperties, ...nonSubjectProperties]

        let rank = 0

        propertyList.forEach((prop) => {
            rank = rank + 1
            selectedProps.push(
                {
                    "omniViewPropertyId": prop.omniViewPropertyId,
                    "isSubjectProperty": prop.isSubjectProperty,
                    "rank": rank,
                    "action": "add"
                })
        })

        fieldsToUpdate.push({ key: 'ownerId', value: user_SFId })
        fieldsToUpdate.push({ key: 'name', value: listName })
        fieldsToUpdate.push({ key: 'compType', value: listType })
        fieldsToUpdate.push({ key: 'polarisSearchCriteria', value: '' })
        fieldsToUpdate.push({ key: 'compsList', value: selectedProps })
        fieldsToUpdate.push({ key: 'average', value: true })
        fieldsToUpdate.push({ key: 'highLow', value: false })
        fieldsToUpdate.push({ key: 'effectiveRents', value: false })
        fieldsToUpdate.push({ key: 'marketRents', value: true })
        fieldsToUpdate.push({ key: 'polarisUserName', value: keycloak.tokenParsed.name })

        return fieldsToUpdate
    }

    const validiateListExists = () => {
        let isExisits = false
        let newListName = listName.trim()
        const index = savedLists.findIndex(x => x.name.toLowerCase() === newListName.toLowerCase() && x.isCart)
        if (index !== -1) {
            isExisits = true
        }

        return isExisits
    }

    const createAlert = listId => {

        return (
            <>
                <span>
                    List Created. <span><a className="btn btn-link underline" onClick={() => { viewList(listId, '', setSelectedMenu) }}><strong>View</strong></a></span>
                </span>
            </>
        )
    }


    const onRecordCreation = async (message, type) => {

        try {

            if (type === 'success') {
                await fetchSavedLists()
                clearSelectedProperties(searchResult, setSearchResult)
            }
            setalertProps({ message, type, duration: type === 'error' ? getErrorAlertDuration() : '' })
            setShowAlert(true)
            openModalWindow(false)

        } catch (error) {
            console.log(' error in onRecordCreation :: ', error)
        }

    }

    const handleSave = async () => {
        try {
            if (listName.length !== 0) {
                let propertyInfoCacheObj = localStorage.getItem('propertyInfo') ? JSON.parse(localStorage.getItem('propertyInfo')) : {}
                searchResult.property.forEach(pro => {
                    propertyInfoCacheObj[pro.omniViewPropertyId.substring(0, pro.omniViewPropertyId.length - 3)] = pro.propertyName;
                })
                localStorage.setItem('propertyInfo', JSON.stringify(propertyInfoCacheObj));
                setListName(listName.trim())
                if (validiateListExists()) {
                    setalertProps({ message: `List with Name ${listName} already exist!!`, type: 'error' })
                    setShowAlert(true)
                    setSaveClicked(false)
                    return
                }

                openModalWindow(true)
                props.handleClose()
                const updatePropertyListObj = new updatePropertyList(getPayload(), "add")
                const response = await updatePropertyListObj.update()

                setSaveClicked(false)

                if (response && response.status === 200) {
                    let messageId = response.data.messageId
                    pollMessageStatus(messageId, onRecordCreation, createAlert, '', 'Unable to fetch list details. Please refresh and open list from Saved lists')

                } else {
                    const errorMessage = response.data && response.data.message ? response.data.message : 'Something went wrong !!'
                    setalertProps({ message: errorMessage, type: 'error' })
                    setShowAlert(true)
                }

            }
        }
        catch (e) {
            console.log('Error :: ', e)
        }
    }

    const handleSubjectClick = option => {

        let index = optionsList.findIndex(x => x.omniViewPropertyId === option.omniViewPropertyId)
        if (index !== -1) {
            let newOptionsList = [...optionsList]
            newOptionsList[index].isSubjectProperty = !newOptionsList[index].isSubjectProperty
            setOptionsList([...newOptionsList])
        }

    }

    return (
        <>
            <div className='h-max-80 flex flex-col py-4 gap-4 drawer-w'>
                <div className='bg-white flex flex-row border-b-1 border-base px-4 pb-2'>
                    <span className='pb-4'>
                        <Add></Add>
                    </span>
                    <span className='px-2'>
                        Save new list
                    </span>
                </div>
                <div className='pt-4 pb-8 px-8 flex flex-col gap-2'>
                    <div className='text-2'>
                        <label>List Name</label>
                    </div>
                    <div className="mb-3">
                        <SimpleInputField testid='test-input-save-new-list' value={listName} onChange={handleChange} type='' placeholder=''></SimpleInputField>
                        {!listName ?
                            <div className="flex flex-row-reverse">
                                <small className="text-danger">*Please enter list name</small>
                            </div>
                            : null}
                    </div>
                    <div className='text-2'>
                        <label>List Type</label>
                    </div>
                    <div className="">
                        <div className="w-full flex flex-wrap md:flex-row">
                            <button onClick={() => { setListType('Rent') }} className={`btn btn-sm border-base mr-3 mb-4 ${listType.toLowerCase() === 'rent' ? 'bg-gray-10 text-primary' : 'bg-white'}`} >
                                <span className="pl-2"><Equalizer fontSize="small" /></span>
                                <span className="px-4">Rent Comp</span>
                            </button>
                            <button onClick={() => { setListType('Sales') }} className={`btn btn-sm border-base mr-3 mb-4 ${listType.toLowerCase() === 'sales' ? 'bg-gray-10 text-primary' : 'bg-white'}`}>
                                <span className="pl-2"><TrendingUp fontSize="small" /></span>
                                <span className="px-4">Sales Comp</span>
                            </button>
                        </div>
                        {!listType ?
                            <div className="flex flex-row-reverse">
                                <small className="text-danger">*Please select list type</small>
                            </div>
                            : null}
                    </div>
                    <div>                            
                        <small className="text-danger">{selectedPropertyCount > 199 ? '* You cannot add more than 199 properties to list' : ''}</small>
                    </div>
                    <div className='text-2'>
                        <label>Subject</label>
                    </div>
                    <div className='overflow-y-hidden overflow-x-hidden'>
                        {optionsList.map(option => {
                            return (
                                option.isSubjectProperty ?
                                    <span onClick={() => handleSubjectClick(option)}
                                        className={`capitalize badge rounded-pill py-3 px-4 mr-3 mb-4 cursor-pointer ${option.isSubjectProperty ? 'text-primary' : 'bg-white border-1 border-base'}`} >
                                        {option.label}
                                        {option.isSubjectProperty ?
                                            <button type="button">
                                                <i className="fa fa-close"></i>
                                            </button>
                                            : null}
                                    </span>
                                    : null
                            )
                        })}
                    </div>
                    <div className='text-2'>
                        <label>Comps</label>
                    </div>
                    <div className='overflow-y-hidden overflow-x-hidden'>
                        {optionsList.map(option => {
                            return (
                                !option.isSubjectProperty ?
                                    <span onClick={() => handleSubjectClick(option)}
                                        className={`capitalize badge rounded-pill py-3 px-4 mr-3 mb-4 cursor-pointer ${option.isSubjectProperty ? 'text-primary' : 'bg-white border-1 border-base'}`} >
                                        {option.label}
                                        {option.isSubjectProperty ?
                                            <button type="button">
                                                <i className="fa fa-close"></i>
                                            </button>
                                            : null}
                                    </span>
                                    : null
                            )
                        })}
                    </div>
                    {/* <select onChange={($event) => { onChange($event) }} className={'form-control block appearance-none bg-white px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline'}>
                        {optionsList.map(option => {
                            return (
                                <option key={option.value} value={option.value} selected={option.isSubjectProperty}>
                                    {option.label}
                                </option>
                            )
                        })}
                    </select> */}

                </div>
                <div className='py-4 px-4 sticky bottom-0 bg-white border-t-1 border-base'>
                    <div className='flex justify-end space-x-4 mt-auto'>
                        <div>
                            <button data-testid='test-button-cancel' onClick={props.handleClose} className='btn btn-sm' type='button'>Close</button>
                        </div>
                        <div>
                            {saveClicked ?
                                <button className="btn btn-sm btn-primary c-disabled">
                                    <span className="loader h-5 w-5 mx-2" ></span>
                                    <span className="px-2">Saving</span>
                                </button>
                                :
                                <button data-testid='test-button-apply' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary ${listName.length === 0 || listType === '' || selectedPropertyCount > 199 ? 'c-disabled cursor-not-allowed' : ''}`}>Save list</button>
                            }
                            {/* <button data-testid='test-button-apply' onClick={() => { setSaveClicked(true) }} className={`btn btn-sm btn-primary ${listName.length === 0 ? 'c-disabled' : ''}`}>Save list</button> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SaveNewList

SaveNewList.propTypes = {
    handleClose: PropTypes.any,
}
